module.exports = __webpack_public_path__ + "static/media/RA-QC1701L_02.64ea38de.png";